import { toast } from 'sonner';

export default function errorRender(error: any) {
  if (error.response.data.errors) {
    for (let index = 0; index < error.response.data.errors.length; index++) {
      const element = error.response.data.errors[index];
      toast.error(element.message);
    }
    return false;
  }
  return true;
}
